<style scoped lang="scss">
.actions {
    display: flex;
}
</style>
<template>
    <div>

        <datatable-search :search="search" :fields="[{fields: ['id'], type: 'OrWhere'}, 'name']"></datatable-search>

        <datatable-add v-can:collections.add :search="search" :href="'collections/add'">{{ trans.get('general.add') }}</datatable-add>

        <div class="table-responsive">
            <table class="table table-striped table-bordered table-hover dataTables">
                <thead>
                    <tr>
                        <th width="60">
                            <datatable-sort :search="search" :field="'id'">{{ trans.get('collections.id') }}</datatable-sort>
                        </th>
                        <th width="50%">
                            <datatable-sort :search="search" :field="'name'">{{ trans.get('collections.name') }}</datatable-sort>
                        </th>
                        <th width="50%">
                            <datatable-sort :search="search" :field="'slug'">{{ trans.get('collections.slug') }}</datatable-sort>
                        </th>
                        <th width="100"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in search.pageObject.data">
                        <td>{{ row.id }}</td>
                        <td>{{ row.name }}</td>
                        <td>{{ row.slug }}</td>
                        <td class="actions">
                            <datatable-edit v-can:collections.edit :href="'collections/edit/' + row.id">{{ trans.get('general.edit') }}</datatable-edit>
                            <datatable-delete v-can:collections.destroy :href="'/dynamic/collections/' + row.id" :search="search" :item="row.name">{{ trans.get('general.delete') }}</datatable-delete>
                        </td>
                    </tr>
                </tbody>
            </table>

            <datatable-paging :search="search"></datatable-paging>

        </div>
    </div>
</template>

<script>
    import { VueSearch } from '@admin/shared/datatable/search';

    export default {

        data() {
            return {
                search: new VueSearch({url: '/dynamic/collections', name: 'collections'}),
            };
        },

    }
</script>
